import React, { useState } from 'react';
import { PersonaForm, PersonaFormProps, TouchedFields } from './PersonaForm';
import { PersonaFormColombia, CiudadCO } from './PersonaFormColombia';
import { TipoVia } from './DireccionColombiaForm';
import { DatosRemitente as DatosRemitenteType } from './EnvioNacionalModal.types';
import { PersonaFormFields } from './EnvioNacionalModal.utils';

export interface DatosPersonaEnvioProps {
  datos: DatosRemitenteType;
  onChange: (field: keyof DatosRemitenteType, value: string) => void;
  isLoadingMunicipio?: boolean;
  errorCodigoPostal?: string | null;
  pais?: string;
  ciudadesCO?: CiudadCO[];
  tiposViaCO?: TipoVia[];
  isLoadingCiudadesCO?: boolean;
  onCiudadSelect?: (ciudad: CiudadCO) => void;
  onDireccionChange?: (tipoVia: string, via: string, numeroVia: string, direccion: string) => void;
  labels: { titulo: string; nombre: string; colonia: string };
  labelsCO: { titulo: string; nombre: string };
}

const noopCiudad = (_ciudad: CiudadCO) => undefined;
const noopDireccion = (_tipoVia: string, _via: string, _numeroVia: string, _direccion: string) => undefined;

export const DatosPersonaEnvio: React.FC<DatosPersonaEnvioProps> = ({
  datos, onChange,
  pais = 'MX',
  ciudadesCO = [], tiposViaCO = [], isLoadingCiudadesCO = false,
  onCiudadSelect = noopCiudad,
  onDireccionChange = noopDireccion,
  labels, labelsCO,
  ...rest
}) => {
  const [touched, setTouched] = useState<TouchedFields>({});
  const markTouched = (field: keyof PersonaFormFields) =>
    setTouched(prev => ({ ...prev, [field]: true }));

  if (pais === 'CO') {
    return (
      <PersonaFormColombia
        datos={datos}
        labels={labelsCO}
        ciudades={ciudadesCO}
        tiposVia={tiposViaCO}
        isLoadingCiudades={isLoadingCiudadesCO}
        onChange={onChange}
        onCiudadSelect={onCiudadSelect}
        onDireccionChange={onDireccionChange}
      />
    );
  }

  return (
    <PersonaForm
      datos={datos}
      onChange={onChange as PersonaFormProps['onChange']}
      labels={labels}
      touched={touched}
      onMarkTouched={markTouched}
      {...rest}
    />
  );
};
